// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import $ from "jquery"

// Configure jQuery globally
window.$ = window.jQuery = $
window.bootstrap = bootstrap
